import {EventEmitter} from 'events';

class ModalManager extends EventEmitter {
  constructor() {
    super();
  }

  open(data) {
    this.emit('toggle', data);
  }

  close(data) {
    this.emit('toggle', data);
  }

  addToggleListener(callback) {
    this.addListener('toggle', callback);
  }

  removeToggleListener(callback) {
    this.removeListener('toggle', callback);
  }
}

export default new ModalManager();
